export const isRedirect = (category) => category.redirectToId && category.redirectToId > 0;

export const isForm = (category) => category.formFields && category.formFields.length > 0;

export const isParentCategory = (category) => (
	category.subCategories && category.subCategories.length > 0
);
